import type { FC } from "react"
import React from "react"
import { Stack } from "@chakra-ui/react"

import type { Proposal } from "query/graphql"
import { useProposalMobileButtonsQuery } from "query/graphql"
import ProposalOnChainCTA from "proposal/components/ProposalOnChainCTA"

type ProposalMobileButtonsProps = {
  proposalId: string
  slug: string
}

const ProposalMobileButtons: FC<ProposalMobileButtonsProps> = ({
  proposalId,
  slug,
}) => {
  const { data, isLoading } = useProposalMobileButtonsQuery({
    input: {
      id: proposalId,
    },
  })

  if (isLoading) return null

  if (!data) return null

  const { proposal } = data

  return (
    <Stack
      bg="white"
      bottom={0}
      display={{ base: "flex", lg: "none" }}
      left={0}
      position="fixed"
      px={5}
      py={4}
      right={0}
      zIndex={5}
    >
      <ProposalOnChainCTA proposal={proposal as Proposal} slug={slug} />
    </Stack>
  )
}

export default ProposalMobileButtons
